import React from 'react'
import PropTypes from 'prop-types'

const Price = ({price, code = 'AUD'}) => {
  let priceFormatted = parseFloat(price).toFixed(1)
  if (priceFormatted.toString().endsWith(0)) priceFormatted = parseInt(priceFormatted, 10)
  return <span className='Price'>{`${priceFormatted} ${code}`}</span>
}

Price.propTypes = {
  price: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  code: PropTypes.string
}

export default Price



// WEBPACK FOOTER //
// ./src/Shop/Price.js